import styled from "styled-components";
import { transparentize } from "polished";

export const Wrapper = styled.div<{
  $invalid?: boolean;
  $disabled?: boolean;
  $neverHideInput?: boolean;
  $keyboardNavigating?: boolean;
}>`
  font-size: 1rem;

  .react-select__control {
    padding: 0;
    font-size: 0.9375em;

    background-color: ${(p) => {
      if (p.$disabled) return p.theme.input.disabled.background;
      if (p.$invalid) return p.theme.input.invalid.background;
      return p.theme.input.default.background;
    }};

    border-radius: 2px;
    border: 1px solid
      ${(p) =>
        p.$invalid
          ? p.theme.input.invalid.border
          : p.theme.input.default.border};

    color: ${(p) =>
      p.$disabled ? p.theme.input.disabled.text : p.theme.input.default.text};

    cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};

    &:hover {
      border-color: ${(p) =>
        p.$invalid ? p.theme.input.invalid.border : p.theme.input.hover.border};
    }
  }

  .react-select__value-container {
    margin: 0;
    padding: 0;
  }

  .react-select__value-container--is-multi {
    padding: 0 8px;

    display: flex;
    row-gap: 4px;
  }

  .react-select__single-value,
  .react-select__input-container,
  .react-select__placeholder {
    margin: 0;
    padding: 6px 16px 6px 13px;
    color: inherit;
  }

  .react-select__multi-value {
    margin: 0 2px;
  }

  .react-select__input-container {
    color: ${(p) =>
      p.$invalid ? p.theme.input.invalid.text : p.theme.input.default.text};
  }

  .react-select__control--is-focused {
    border-color: ${(p) =>
      p.$invalid ? p.theme.input.invalid.border : p.theme.input.focused.border};
    box-shadow: none;

    &:hover {
      border-color: ${(p) =>
        p.$invalid
          ? p.theme.input.invalid.border
          : p.theme.input.focused.border};
    }
  }

  .react-select__control--menu-is-open {
    .react-select__dropdown-indicator {
      transform: rotate(180deg);
    }
  }

  .react-select__menu {
    font-size: 0.9375em;
    margin-top: 0.125em;
    border-radius: 2px;
    width: max-content;
    min-width: 100%;

    background-color: ${(p) => p.theme.input.default.background};
    box-shadow: ${(p) => transparentize(0.25, p.theme.overlayMenu.shadow)} 0px
      8px 36px 0px;
  }

  .react-select__option--is-focused {
    background-color: ${(p) => p.theme.input.hover.background};
    color: ${(p) => p.theme.input.hover.text};
  }
  .react-select__option--is-selected {
    background-color: ${(p) => p.theme.link.default};
    color: ${(p) => p.theme.color.palette.white};
  }
  .react-select__option:hover {
    background-color: ${(p) => p.theme.input.hover.background};
    color: ${(p) => p.theme.input.hover.text};
  }

  ${(p) =>
    p.$keyboardNavigating &&
    `
    .react-select__option:not(.react-select__option--is-focused):hover {
      background-color: transparent;
      color: inherit;
    }
  `}

  ${(p) =>
    p.$neverHideInput &&
    `
    .react-select__control:not(.react-select__control--is-focused)
      .react-select__input-container {
      color: ${p.theme.text.muted};
    }
  `}

  .react-select__dropdown-indicator {
    font-size: 1.25em;
    color: ${(p) =>
      p.$invalid ? p.theme.input.invalid.text : p.theme.input.default.text};
    transform: rotate(0);
    transition: transform 0.1s ease;

    &:hover {
      color: ${(p) => p.theme.input.hover.text};
    }
  }

  .react-select__control[aria-disabled="true"]
    .react-select__dropdown-indicator {
    color: ${(p) => p.theme.input.disabled.text};
  }

  .react-select__multi-value__remove {
    color: hsl(0, 0%, 30%); /* adapted from react-select__multi-value__label */
  }
`;
